import { z } from "zod";
import { InsuranceCategoryEnumSchema } from "@/Schemas/PublicRequest/InsuranceCategoryEnum";
import { RequestMasterTypeEnumSchema } from "@/Schemas/PublicRequest/RequestMasterTypeEnum";

export const PublicRequestFieldSchema = z.object({
    key: z.string(),
    value: z.string(),
});

export type PublicRequestField = z.infer<typeof PublicRequestFieldSchema>;

export const PublicRequestValidateOutputSchema = z.object({
    token: z.string(),
    requestMasterType: RequestMasterTypeEnumSchema,
    insuranceCategory: InsuranceCategoryEnumSchema,
    productName: z.string(),
    fields: z.array(PublicRequestFieldSchema),
    flags: z.record(z.string(), z.boolean()),
});

export type PublicRequestValidateOutput = z.infer<typeof PublicRequestValidateOutputSchema>;
